<template>
	<div class="verify" @click="verifyClick">
		<el-popover placement="top" trigger="click">
			<div ref="verifyCh" id="verifyCh"></div>
			<div
				slot="reference"
				v-if="codeResult"
				:class="visible ? 'code-cli' : 'code-main'"
			>
				<i v-if="!visible" class="el-icon-circle-check"></i>
				<span v-if="!codeSucss">{{ $t('login.ClickToVerify') }}</span>
				<span v-else>{{ $t('login.VerifyCompleted') }}</span>
			</div>
			<div slot="reference" v-if="!codeResult" class="codeError">
				<i class="el-icon-circle-close"></i>
				{{ $t('login.ClickToVerify') }}
			</div>
		</el-popover>
	</div>
</template>

<script>
import img1 from '@/assets/verify/images/1.jpg'
import img2 from '@/assets/verify/images/2.jpg'

export default {
	name: 'verify',
	data() {
		return {
			text: this.$t('login.toTheRight'),
			imgs: [img1, img2],
			visible: true,
			codeResult: true,
			codeSucss: false,
			sucss: true,
			options: null
		}
	},
	mounted() {
		const that = this
		require(['jquery'], $ => {
			window.jQuery = $
			require(['@/plugins/verify/js/verify'], () => {
				$('#verifyCh').pointsVerify({
					defaultNum: 4, //默认的文字数量
					checkNum: 2, //校对的文字数量
					vSpace: 5, //间隔
					imgName: [img1, img2],
					imgSize: {
						width: '306x',
						height: '200px'
					},
					barSize: {
						width: '306px',
						height: '40px'
					},
					ready: function (options) {
						that.options = options
					},
					success: function () {
						that.onSuccess()
					},
					error: function () {
						that.onFail()
					},
					refresh: function () {
						that.onRefresh()
					}
				})
			})
		})
	},
	methods: {
		verifyClick() {
			this.options && this.options.refresh && this.options.refresh()
		},
		onSuccess() {
			this.visible = false
			this.isCompleteHumanRobotVertify = true
			this.codeResult = true
			this.codeSucss = true
			this.$emit('codeSucss', this.codeSucss)
			let e = document.createEvent('MouseEvents')
			e.initEvent('click', true, true)
			document.getElementsByClassName('verify')[0].dispatchEvent(e)
		},
		onFail() {
			this.visible = true
			this.isCompleteHumanRobotVertify = false
			this.codeResult = false
			this.codeSucss = false
			this.$emit('codeSucss', this.codeSucss)
		},
		onRefresh() {
			this.visible = true
			this.isCompleteHumanRobotVertify = false
			this.codeSucss = false
			this.$emit('codeSucss', this.codeSucss)
		},
		onFulfilled() {
			this.visible = true
			this.isCompleteHumanRobotVertify = false
			this.codeSucss = false
		},
		onAgain() {
			this.msg = 'try again'
			// 刷新
			this.handleClick()
		},
		handleClick() {
			// this.$refs.slideblock.reset();
			this.visible = true
			this.isCompleteHumanRobotVertify = false
			this.codeResult = true
			this.codeSucss = false
			this.$emit('codeSucss', this.codeSucss)
		}
	}
}
</script>

<style lang="scss" scoped>
/* 拼图验证码按钮样式 */
.code-cli {
	line-height: 48px;
	text-align: center;
	font-size: theme('fontSize.smallPlus');
	color: theme('colors.text.secondary');
	cursor: pointer;
	z-index: 2;
	border: 1px solid theme('colors.border');
	margin-top: 30px;
	border-radius: theme('borderRadius.middle');
}

.code-main {
	line-height: 48px;
	text-align: center;
	font-size: theme('fontSize.smallPlus');
	color: #67c23a;
	cursor: pointer;
	z-index: 2;
	border: 1px solid #67c23a;
	margin-top: 30px;
	border-radius: theme('borderRadius.middle');
}

.codeError {
	line-height: 48px;
	text-align: center;
	font-size: theme('fontSize.smallPlus');
	color: #f56c6c;
	cursor: pointer;
	z-index: 2;
	border: 1px solid #f56c6c;
	margin-top: 30px;
	border-radius: theme('borderRadius.middle');
}
</style>

<style lang="scss">
.recaptcha {
	position: relative;
	height: 78px;
}

.recaptcha .g-recaptcha {
	position: absolute;
	left: 50%;
	top: 0;
	height: auto !important;
	overflow: initial !important;
	transform: translateX(-50%);
}

.recaptcha .g-recaptcha > div {
	margin: 0 auto;
}

/*.recaptcha .g-recaptcha>div,
.recaptcha .g-recaptcha iframe {
  width: 100% !important;
}*/
</style>
